import React from 'react';
import 'video.js/dist/video-js.css';
import TR from './../../Trans';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import { ReactComponent as PlayIcon } from './../../assets/play.svg';
import { ReactComponent as PauseIcon } from './../../assets/pause.svg';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import SvgIcon from '@mui/material/SvgIcon';
import IntervalService from './../../services/intervals';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import Typography from '@mui/material/Typography';
import navigationStore from '../../stores/navigation';
import playerStore from './../../stores/player';
import performanceStore from '../../stores/performance';
import sessionStore from '../../stores/session';

function MobilePlayerCard(props) {

  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const isPlaying = playerStore((state) => state.isPlaying);
  const safeArea = navigationStore((state) => state.safeArea);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const setFrom = playerStore((state) => state.setFrom);
  const history = performanceStore((state) => state.history);
  const getStreamUrl = playerStore((state) => state.getStreamUrl);
  const getNextPerformance = performanceStore((state) => state.getNextPerformance);
  const deletePerformance = performanceStore((state) => state.deletePerformance);
  const addPerformanceToHistory = performanceStore((state) => state.addPerformanceToHistory);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const currentVersion = playerStore((state) => state.currentVersion);
  const isPlayListOn = performanceStore((state) => state.isOn);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const prevFromHistory = performanceStore((state) => state.prevFromHistory);
  const isStopped = playerStore((state) => state.isStopped);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const setCurrentTime = playerStore((state) => state.setCurrentTime);
  const isFocused = playerStore((state) => state.isFocused);
  const setIsReady = playerStore((state) => state.setIsReady);
  const isReady = playerStore((state) => state.isReady);
  const currentTrack = playerStore((state) => state.currentTrack);
  const streamUrl = playerStore((state) => state.streamUrl);
  const isSwitching = playerStore((state) => state.isSwitching);

  const play = () => {
    console.log("network error", isFocused, isReady, currentPerformance, currentTrack);
    if (isFocused && isReady && !isSwitching) {
      setIsReady(false);
      if (currentPerformance && currentTrack) {
        console.log("currentTrack", isFocused, currentPerformance, currentTrack, streamUrl);
        IntervalService.clearAllIntervals();
        setIsPlaying(true);
        setIsStopped(false);
        if (streamUrl === "") {
          getStreamUrl(sessionToken, currentPerformance, currentTrack, currentPerformance.pitch, currentVersion, 0, true);
        }
      } else {
        if (streamUrl === "") {
          setIsStopped(false);
          getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, currentPerformance.pitch, currentVersion, 0, true);
        }
      }
    }
  };

  const pause = () => {
    if (isReady) {
      setIsReady(false);
      setIsPlaying(false);
    }
  };

  const renderPauseOrPlay = () => {
    if (isPlaying.isPlaying) {
      return <IconButton className="muvika-mobile-player-button" color="white" component="label" size="small" onClick={(e) => {
        e.stopPropagation();
        pause();
      }}>
        <SvgIcon className="muvika-icon" component={PauseIcon} />
      </IconButton>;
    } else {
      return <IconButton className="muvika-mobile-player-button" color="white" component="label" size="small" onClick={(e) => {
        e.stopPropagation();
        play();
      }}>
        <SvgIcon className="muvika-icon" component={PlayIcon} />
      </IconButton>;
    }
  };

  const renderContent = () => {
    if (props.isEmpty) {
      return <>
        <Box className="muvika-mobile-player-card-content-box">
          <CardContent className="muvika-mobile-player-card-content-div">
            <Grid container spacing={0.5}>
              <Grid item xs={1.5} sx={{ textAlign: "center" }}>
                <IconButton className="muvika-mobile-player-button" color="white" component="label" size="small">
                  <SvgIcon className="muvika-icon" component={PlayIcon} />
                </IconButton>
              </Grid>
              <Grid item xs={10.5}>
                <span className="muvika-mobile-player-empty">{TR.cm_playqueue_is_empty}</span>
              </Grid>
            </Grid>
          </CardContent>
        </Box>
      </>;
    } else {
      return <>
        <CardMedia
          component="img"
          className="muvika-mobile-player-card-image"
          image={props.image}
        />
        <Box className="muvika-mobile-player-card-content-box">
          <CardContent className="muvika-mobile-player-card-content-div">
            <Grid container spacing={0.5}>
              <Grid item xs={1.5} sx={{ textAlign: "center" }}>
                {renderPauseOrPlay()}
              </Grid>
              <Grid item xs={7.5}>
                <Typography className="muvika-mobile-player-card-content-title" component="div" variant="primary">
                  {props.secondary}
                </Typography>
                <Typography className="muvika-mobile-player-card-content-artist" variant="secondary" color="text.secondary" component="div">
                  {props.primary}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Grid container spacing={0} sx={{ textAlign: "right", paddingRight: "0rem" }}>
                  <Grid item xs={10}>
                    <Typography className="muvika-mobile-player-card-content-title" component="div" variant="primary">
                      <span>{(props.pitch != 0 ? (props.pitch > 0 ? "+" : "") + props.pitch + " " : "")} {props.length}</span>
                    </Typography>
                    <Typography className="muvika-mobile-player-card-content-artist" variant="secondary" color="text.secondary" component="div">
                      {props.kcode}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Box>
      </>;
    }
  };

  return (
    <Card
      id="muvika-mobile-player-card"
      className="muvika-mobile-player-card"
      elevation={10}
      onClick={props.onClick}
      sx={{
        bottom: safeArea ? "calc(" + safeArea.bottom + "px + 3.45rem) !important" : "3.45rem !important",
        paddingLeft: safeArea ? safeArea.left + "px" : 0,
        paddingRight: safeArea ? safeArea.right + "px" : 0
      }}
    >
      {renderContent()}
      <OpenInFullIcon className="muvika-mobile-player-card-full-icon" />
    </Card>
  );
}

export default MobilePlayerCard;